import { Box, Paper, Skeleton } from "@mui/material";
import React from "react";

const HomeDashboardSkeleton: React.FC = () => {
  const activityFeedHeight = `calc(100vh - 12.4rem)`;
  const halfHeight = `calc((100vh - 12.4rem - 1.6rem) / 2)`;

  return (
    <Box
      sx={{
        px: 8.75,
        py: 5.25,
        maxWidth: "194.2rem",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        flexDirection: "row",
        gap: 3,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {/* Left Column: ActivityFeed */}
      <Box sx={{ flex: 8 }}>
        <Paper
          sx={{
            height: activityFeedHeight,
            borderRadius: ".5em",
            backgroundColor: "background.card.main",
            p: 0,
          }}
        >
          {/* Toolbar */}
          <Box
            sx={{
              px: 3,
              py: 2.5,
              mb: 3,
              borderRadius: ".5em .5em 0 0",
              minHeight: "7rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <Skeleton variant="text" width={80} height={40} />
              <Skeleton variant="text" width={120} height={40} />
            </Box>
            <Skeleton
              variant="rectangular"
              width={100}
              height={30}
              sx={{ borderRadius: ".8rem" }}
            />
          </Box>
        </Paper>
      </Box>

      {/* Right Column: My List and Client Notification */}
      <Box
        sx={{
          flex: 4,
          minWidth: "42rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* MyList */}
        <Paper
          sx={{
            height: halfHeight,
            borderRadius: ".5em .5em",
            mb: 2,
            p: 0,
            backgroundColor: "background.card.main",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2.5,
              mb: 3,
              borderRadius: ".5em .5em 0 0",
            }}
          >
            <Skeleton variant="text" width={160} height={40} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width={320} height={40} />
          </Box>
        </Paper>

        {/* Client Notifications */}
        <Paper
          sx={{
            height: halfHeight,
            borderRadius: ".5em .5em 0 0",
            p: 0,
            backgroundColor: "background.card.main",
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              mb: 3,
              borderRadius: ".5em .5em 0 0",
            }}
          >
            <Skeleton variant="text" width={180} height={40} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width={320}
              height={40}
              sx={{ mb: 2 }}
            />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default HomeDashboardSkeleton;
